<template>
  <a-card :bordered="false">
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      :enableSearch="false"
      :requestPromise="loadPromise"
      :columns="getColumns()">
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要重新发码" @confirm="resendSendCode(rowItem.record)"
                      v-if="rowItem.record.orderState==5">
          <a>重新发码</a>
          <a-divider type="vertical"/>
        </a-popconfirm>
        <a @click='onClickOpen(rowItem.record)'>出票信息</a>
      </span>
    </custom-page-table>
    <a-modal title="重新发码" :visible="resendSendCodeDialogVisible" @ok="sendCode"
             @cancel="resendSendCodeDialogVisible = false">
      <div>
        <a-form-item label="接收手机号" v-bind="lineItemLayout">
          <a-input :maxLength="11" v-model="resendSendCodeVo.orderMobile" placeholder="请输入手机号码"></a-input>
        </a-form-item>
        <a-form-item label="短信内容" v-bind="lineItemLayout">
          <a-textarea :rows="4" v-model="resendSendCodeVo.message" :disabled="true"></a-textarea>
        </a-form-item>
      </div>
    </a-modal>

    <a-modal width="750px" title="出票信息" :visible="ticketInfoDialog" @cancel="ticketInfoDialog = false"
             :footer="null">
      <a-table
        :columns="getUsersColumns()"
        rowKey="key"
        :dataSource="ticketUserList" :pagination="false">
          <span slot="action" slot-scope="text, record">
            <a-popconfirm title="是否确认退票" @confirm="confirmEvent(record)">
              <a v-if='record.status==0'>申请退票</a>
            </a-popconfirm>
          </span>
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'OrderConnection',
  components: {},
  data() {
    return {
      lineItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      ticketInfoDialog: false,
      queryUsersParams: {},
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        orderType: 3
      },
      resendSendCodeDialogVisible: false,
      loadPromise: params => this.getListPromise(params),
      resendSendCodeVo: {},
      resendSendCodeId: 0,
      ticketUserList: [],
      ticketInfo: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'zhiyoubaoConnection', title: '商品绑定' },
      { name: 'zybOrderConnection', title: '订单直连' },
      { name: 'zybRelationAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getDirectTicketsService().post('directTickets/order/selectOrderList', params)
    },
    onClickOpen(record) {
      this.ticketInfoDialog = true
      this.ticketInfo = record
      this.getTicketNoList(record.id)
    },
    getTicketNoList(id) {
      const params = {
        id: id
      }
      this.getHttpServices().getDirectTicketsService().post('directTickets/order/selectTicketNoList', params).then(res => {
        if (res && res.length > 0) {
          this.ticketUserList = res
        } else {
          this.ticketUserList = []
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    resendSendCode(item) {
      let params = {
        id: item.id,
        orderMobile: item.orderMobile
      }
      this.resendSendCodeId = item.id
      this.getHttpServices().getDirectTicketsService().post('directTickets/order/querySmsInfo', params)
        .then(res => {
          this.resendSendCodeVo = res
          this.resendSendCodeDialogVisible = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))

    },
    sendCode() {
      if (!/^1[3456789]\d{9}$/.test(this.resendSendCodeVo.orderMobile) || !this.resendSendCodeVo.orderMobile) {
        return this.$message.error('请输入正确的手机号码')
      }
      let params = {
        id: this.resendSendCodeId,
        orderMobile: this.resendSendCodeVo.orderMobile
      }
      this.getHttpServices().getDirectTicketsService().post('directTickets/order/againSendSms', params)
        .then(res => {
          this.$message.success('发送成功')
          this.resendSendCodeDialogVisible = false
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    confirmEvent(record) {
      console.error('confirmEvent', record)
      const params = {
        orderNo: record.orderNo,
        source: this.ticketInfo.orderSource,
        directType: 9,
        ticketId: record.id
      }
      this.getHttpServices().getOrderService().post('direct/refund/directApplyRefund', params)
        .then(res => {
          this.$message.success('操作成功')
          setTimeout(() => {
            this.ticketInfoDialog = false
            this.$refs.table.refresh(true)
          }, 800)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: '景区订单号',
          dataIndex: 'orderSupplierNo'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '下单用户',
          dataIndex: 'orderContact'
        },
        {
          title: '订单来源',
          dataIndex: 'orderSourceName'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStateName'
        },
        {
          title: '下单时间',
          dataIndex: 'createDate'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getUsersColumns() {
      return [
        {
          title: '姓名',
          key: 'customerName',
          dataIndex: 'customerName'
        },
        {
          title: '证件号码',
          key: 'customerCard',
          dataIndex: 'customerCard'
        },
        {
          title: '操作状态',
          key: 'statusStr',
          dataIndex: 'statusStr'
        },
        {
          title: '创建时间',
          key: 'createTime',
          dataIndex: 'createTime'
        },
        {
          title: '检票时间',
          key: 'checkTime',
          dataIndex: 'checkTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
